import Layout from "@/layouts/Layout.vue";
import inventoriesList from "@/views/inventories/list.vue";
import inventoryPreview from "@/views/inventories/preview.vue"
import { UserPermissions } from "@/utils";

let inventoriesRoute = {
  path: "/inventories",
  component: Layout,
  name: "Инвентаризации ",
  redirect: "/inventories",
  hidden: true,
  meta: {
    actions: [UserPermissions.USER, UserPermissions.ADMIN],
  },
  children: [
    {
      path: "/inventories",
      name: "Инвентаризации",
      component: inventoriesList,
      meta: {
        title: "Инвентаризации",
        actions: [UserPermissions.USER, UserPermissions.ADMIN],
        icon: "mdi-clipboard-check-multiple-outline",
      },
      hidden: false
    },
    {
      path: "/inventories/:id",
      name: "Преглед на инвентаризация",
      component: inventoryPreview,
      meta: {
        title: "Преглед на инвентаризация",
        actions: [UserPermissions.USER, UserPermissions.ADMIN],
        icon: "mdi-cash-multiple",
        goBackTitle: "Обратно към инвентаризации",
      },
      hidden: true
    }
  ]
}

export default inventoriesRoute;